module.exports = __webpack_public_path__ + "img/141.47a46bb9.jpg";